import request from "../utils/request";

export function createSupportTicket(data) {
  return request({
    url: "/support",
    method: "post",
    data,
  });
}

export function getMySupportTickets(query = {}) {
  return request({
    url: "/support/my",
    method: "get",
    params: {
      page: query.page != null ? query.page : 1,
      size: query.size != null ? query.size : 15,
      sortBy: query.sortBy || "createdAt",
      sortDesc: query.sortDesc != null ? query.sortDesc : true,
      status: query.status || undefined,
      protocol: query.protocol || undefined,
    },
  });
}

export function getSupportTickets(query = {}) {
  return request({
    url: "/support",
    method: "get",
    params: {
      page: query.page != null ? query.page : 1,
      size: query.size != null ? query.size : 15,
      sortBy: query.sortBy || "createdAt",
      sortDesc: query.sortDesc != null ? query.sortDesc : true,
      status: query.status || undefined,
      company: query.company || undefined,
      protocol: query.protocol || undefined,
    },
  });
}

export function getSupportNotifications(company) {
  let query = "?type=support";
  if (company !== undefined) {
    query += `&company=${company}`;
  }

  return request({
    url: `/notifications${query}`,
    method: "get",
  });
}

export function getSupportTicket(id) {
  return request({
    url: `/support/${id}`,
    method: "get",
  });
}

export function addSupportMessage(id, data) {
  return request({
    url: `/support/${id}/messages`,
    method: "post",
    data,
  });
}

export function escalateSupportTicket(id, data) {
  return request({
    url: `/support/${id}/escalate`,
    method: "post",
    data,
  });
}

export function updateSupportStatus(id, data) {
  return request({
    url: `/support/${id}/status`,
    method: "patch",
    data,
  });
}

export function supportFileDownloadUrl(ticketId, messageId, fileId) {
  return `/api/support/${ticketId}/messages/${messageId}/files/${fileId}`;
}
